import React from 'react'
import { Row, Col } from 'react-bootstrap'

export default function EnderecoSection({ children }) {
  return (
    <>
      <Row className="mt-3 pt-2">
        <Col>
          <h2 className="paciente-form-section-title mb-0">Endereço</h2>
        </Col>
      </Row>
      {children}
    </>
  )
}
